// extracted by mini-css-extract-plugin
export default {"badge":"PlusBadge_badge__7X9zB","md":"PlusBadge_md__pyNi-"};